import { type onAfterSaveType } from 'app/main/components/hooks/useModel';
import { DetailsEventsWrapper } from 'app/main/components/page-layouts';
import { sendNotification } from 'app/store/notifications/notificationsHubSlice';

const sendSaveNotification: onAfterSaveType = ({ dispatch, model, modifiedModel }) =>
	new Promise<void>((resolve, reject) => {
		if (
			modifiedModel.reqs_user_assigned_uid &&
			modifiedModel.reqs_user_assigned_uid !== model.reqs_user_modified_uid
		) {
			sendNotification({
				message: {
					createdBy: modifiedModel.reqs_user_modified_uid,
					assignedTo: modifiedModel.reqs_user_assigned_uid,
					title: 'Nuova Segnalazione assegnata',
					body: `${model.user_modified_title} ti ha assegnato a "${model.reqs_title}".`,
					url: `${window.location.origin}/requests/details/${model.reqs_uid}`,
					icon: 'account-voice',
					variant: 'info'
				}
			});
		}

		resolve();
	});

const onAfterSave: onAfterSaveType = params =>
	DetailsEventsWrapper(params.modifiedModel)([sendSaveNotification(params)]);

export default { onAfterSave };
